import { Routes, Route, Navigate } from 'react-router-dom';

import { Seasons } from './components/SeasonsAndZones/components/Seasons';
import { Products } from './components/Products';
import { Orders } from './components/Orders';
import { Catalogs } from './components/Catalogs';
import { NotificationsCategories } from './components/NotificationsCategories';
import { Notifications } from './components/Notifications';
import { Budget } from './components/Budget';
import { SizeScales } from './components/SizeScales';
import { SeasonsAndZones } from './components/SeasonsAndZones/SeasonsAndZones';

export function CataloguePage(): React.ReactElement {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="seasons" />} />

      <Route path="/seasons-and-zones/*" element={<SeasonsAndZones />} />

      <Route path="/products/*" element={<Products />} />

      <Route path="/orders/*" element={<Orders />} />

      <Route path="/catalogs/*" element={<Catalogs />} />

      <Route path="/notifications-categories/*" element={<NotificationsCategories />} />

      <Route path="/notifications/*" element={<Notifications />} />

      <Route path="/budget/*" element={<Budget />} />

      <Route path="/size-scales/*" element={<SizeScales />} />
    </Routes>
  );
}
